<template>
  <div>
    <topsearch title="Lead Atama Ayarları" />

    <div class="content-section">
      <form @submit.prevent="formSubmit()">
        <div class="flex items-center justify-center">
          <div class="flex space-x-2 p-2">
            <div>
              <label>Koşul</label>
              <select class="uk-input" v-model="form.if">
                <option
                  :value="{ id: component.id, name: component.name }"
                  v-for="component in components"
                >
                  {{ component.display_name }}
                </option>
              </select>
            </div>
            <div v-if="form.if">
              <label>Değer</label>
              <template v-if="$root.cache.getOptions[form.if.id]">
                <select class="uk-input" v-model="form.if_value">
                  <option
                    :value="options.value"
                    v-for="options in $root.cache.getOptions[form.if.id]"
                  >
                    {{ options.label }}
                  </option>
                </select>
              </template>
              <input
                type="text"
                v-else
                class="uk-input"
                v-model="form.if_value"
              />
            </div>
          </div>
          <div class="border rounded-full p-2 mt-3">ise</div>
          <div class="p-2 space-x-2 flex" v-if="form.if_value">
            <div>
              <label>Gerçekleşecek Durum</label>
              <select class="uk-input" v-model="form.then">
                <option
                  :value="{ id: component.id, name: component.name }"
                  v-for="component in components"
                >
                  {{ component.display_name }}
                </option>
              </select>
            </div>
            <div v-if="form.then">
              <label>Değer</label>
              <template v-if="$root.cache.getOptions[form.then.id]">
                <select class="uk-input" v-model="form.then_value">
                  <option
                    :value="options.value"
                    v-for="options in $root.cache.getOptions[form.then.id]"
                  >
                    {{ options.label }}
                  </option>
                </select>
              </template>
              <input
                v-else
                type="text"
                class="uk-input"
                v-model="form.then_value"
              />
            </div>
          </div>
          <div class="items-center flex justify-center">
            <save-button title="Kaydet" />
          </div>
        </div>
      </form>

      <div class="flex border-t items-center justify-center">
        <div
          class="border m-2 rounded p-2 flex space-x-2"
          v-for="hook in hooks.results"
        >
          <div class="flex p-2 space-x-2">
            <div>{{ hook.if }} ==</div>
            <div>{{ hook.if_value }}</div>
          </div>
          <div class="flex border-l p-2 space-x-2">
            <div>{{ hook.then }} =</div>
            <div>{{ hook.then_value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SaveButton from "../components/Ui/SaveButton.vue";
import http from "../services/http";

export default {
  components: { SaveButton },
  data() {
    return {
      components: [],
      hooks: [],
      form: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    formSubmit() {
      http.hookSave(this.form).then(resp => {
        if (resp.data.success) {
          this.$root.successMessage("İşlem başarıyla kaydedildi");
          this.getData();
        }
      });
    },
    getData() {
      http
        .getData({
          table: "hooks"
        })
        .then(resp => {
          this.hooks = resp.data;
        });

      http
        .getData({
          table: "leads"
        })
        .then(resp => {
          this.components = resp.data.components;
        });
    }
  }
};
</script>
